import { InternalLink, LinkBlockLink } from '../@types/schema';

const isInternalLink = (link: InternalLink | LinkBlockLink): link is InternalLink => {
  return 'label' in link && 'link' in link;
};

const cleanLinks = (links: InternalLink[] | LinkBlockLink[] | undefined) =>
  links?.map((linkPair: InternalLink | LinkBlockLink) =>
    isInternalLink(linkPair) ? linkPair : { label: linkPair.text, link: linkPair.url }
  );

export default cleanLinks;
